import { EOrderBookType } from "@adapters/features/OrderBook/Presenters/action-interface/OrderBook";
import EqOrderBookUseCases from "@domains/features/OrderBook/useCases/eqOrderBookUseCases";
import CoOrderBookUseCases from "@domains/features/OrderBook/useCases/coOrderBookUseCases";
import MFOrderBookUseCases from "@domains/features/OrderBook/useCases/mfOrderBookUseCases";
import EqSipOrderBookUseCases from "@domains/features/OrderBook/useCases/eqSipOrdeBookUseCases";
import MFSipOrderBookUseCases from "@domains/features/OrderBook/useCases/mfSipOrderBookUseCases";
import NFOOrderBookUsecases from "@domains/features/OrderBook/useCases/nfoOrderBookUseCases";
import SnapQuoteUseCase from "@domains/features/OrderBook/useCases/snapQuoteUseCases";
import MFOrderBookHoldingsUseCases from "@domains/features/OrderBook/useCases/mfOrderBookHoldingsUseCases";
import MFOrderBookCancelUseCase from "@domains/features/OrderBook/useCases/mfOrderBookCancelUseCase";
import NFOOrderBookCancelUseCases from "@domains/features/OrderBook/useCases/nfoOrderBookCancelUseCases";
import IPOOrderBookUseCases from "@domains/features/OrderBook/useCases/ipoOrderBookUseCases";
import MfSipChildOrderBookUseCases from "@domains/features/OrderBook/useCases/mfSipChildOrderBookUseCase";
import OFSOrderBookUsecases from "@domains/features/OrderBook/useCases/ofsOrderbookUseCase";
import OFSCancelOrderUsecases from "@domains/features/OrderBook/useCases/ofsCancelOrderUseCase";
export default (function (repositories) {
    var _a;
    return {
        orderBook: (_a = {},
            _a[EOrderBookType.EQ] = new EqOrderBookUseCases(repositories.OrderEquity),
            _a[EOrderBookType.CO] = new CoOrderBookUseCases(repositories.OrderCommodity),
            _a[EOrderBookType.MF] = new MFOrderBookUseCases(repositories.OrderMutualFunds),
            _a[EOrderBookType.NFO] = new NFOOrderBookUsecases(repositories.OrderNewFundOrder),
            _a[EOrderBookType.EQSIP] = new EqSipOrderBookUseCases(repositories.OrderEquity),
            _a[EOrderBookType.MFSIP] = new MFSipOrderBookUseCases(repositories.OrderMutualFunds),
            _a[EOrderBookType.IPO] = new IPOOrderBookUseCases(repositories.IPO),
            _a.snapQuote = new SnapQuoteUseCase(repositories.OrderEquity),
            _a.nfoOrderCancel = new NFOOrderBookCancelUseCases(repositories.OrderNewFundOrder),
            _a[EOrderBookType.MFH] = new MFOrderBookHoldingsUseCases(repositories.OrderMutualFunds),
            _a.mfOrderCancel = new MFOrderBookCancelUseCase(repositories.OrderMutualFunds),
            _a.mfSipChild = new MfSipChildOrderBookUseCases(repositories.OrderMutualFunds),
            _a.ofsOrderBook = new OFSOrderBookUsecases(repositories.OFS),
            _a.ofsCancelOrder = new OFSCancelOrderUsecases(repositories.OFS),
            _a),
    };
});
